module.exports = __webpack_public_path__ + "static/media/ict.aa07e9f6.png";